import _ from 'lodash';
import { apiFetch, apiSearch, apiRemove } from '../utility';
const apiBase = 'ocrIngestionResult';

export const search = (p = {}) => {
	const { callback = _.noop, doNotIncludeOcrBlocks } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				doNotIncludeOcrBlocks,
			},
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({ ocrIngestionResultId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: ocrIngestionResultId,
			dispatch,
			callback,
		});
	};
};

export const overrideMatchData = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.overrideMatchData`,
			params,
			dispatch,
			callback,
		});
	};
};
